import { createSelector } from 'reselect';
import models from '../../models';
import location from '../../models/locaion';
import { LOCATION_INITIAL_STATE } from '../reducers/location';

const locationSelector = (state: models.GlobalState) => state.location;

export const provinceSelector = createSelector(
    locationSelector,
    data => data.provinces as location.Province[] ?? LOCATION_INITIAL_STATE.provinces
)

export const provinceNewSelector = createSelector(
    locationSelector,
    data => data.provincesNew as location.ProvinceNew[] ?? LOCATION_INITIAL_STATE.provincesNew
)